
<h3 class="text-gray-700 font-bold text-xl mb-6 uppercase">
    @if(type() == "QUANTITY"){
        {{ "MAIN_LAYOUT.BILL_OF_QUANTITIES" | translate }}
    }
    @else {
        {{ "MAIN_LAYOUT.CUT_LIST" | translate }}
    }
</h3>

@if(!printable()) {
<div class="inline-flex flex-wrap">
    @if("QUANTITY" == type()){
        @for (lamellaAreaGroup of lamellaAreaStore.lamellaAreaGroups(); track lamellaAreaGroup.id) {
            <div
                    class="cursor-pointer p-2 flex gap-2 transition-colors border-primary-900 border-t border-x first:border-s-2 last:border-e-2 items-center font-bold uppercase"
                    [class.bg-primary-900]="activeTab === 'Group' && activeGroupId === lamellaAreaGroup.id"
                    [class.text-white]="activeTab === 'Group' && activeGroupId === lamellaAreaGroup.id"
                    [class.text-gray-500]="activeTab !== 'Group' && activeGroupId !== lamellaAreaGroup.id"
                    [class.hover:bg-primary-50]="activeTab !== 'Group' && activeGroupId !== lamellaAreaGroup.id"
                    (click)="switchTab('Group', lamellaAreaGroup.id)"
            >
                <span> {{ lamellaAreaGroup.name }} </span>
            </div>
        }

        <!-- yhteenveto -->
        <div
                class="cursor-pointer p-2 flex gap-2 transition-colors border-primary-900 border-t border-x first:border-s-2 last:border-e-2 items-center font-bold uppercase"
                [class.bg-primary-900]="activeTab === 'Summary'"
                [class.text-white]="activeTab === 'Summary'"
                [class.text-gray-500]="activeTab !== 'Summary'"
                [class.hover:bg-primary-50]="activeTab !== 'Summary'"
                (click)="switchTab('Summary')"
        >
            <span> {{ "GLOBAL.SUMMARY" | translate }} </span>
        </div>
    }
    @else {
        <div
                class="cursor-pointer p-2 flex gap-2 transition-colors border-primary-900 border-t border-x first:border-s-2 last:border-e-2 items-center font-bold uppercase"
                [class.bg-primary-900]="activeTab === 'CuttingPlan'"
                [class.text-white]="activeTab === 'CuttingPlan'"
                [class.text-gray-500]="activeTab !== 'CuttingPlan'"
                [class.hover:bg-primary-50]="activeTab !== 'CuttingPlan'"
                (click)="switchTab('CuttingPlan')"
        >
            <span> {{ "LAMELLA" | translate }} </span>
        </div>

        <div
                class="cursor-pointer p-2 flex gap-2 transition-colors border-primary-900 border-t border-x first:border-s-2 last:border-e-2 items-center font-bold uppercase"
                [class.bg-primary-900]="activeTab === 'MountingProfiles'"
                [class.text-white]="activeTab === 'MountingProfiles'"
                [class.text-gray-500]="activeTab !== 'MountingProfiles'"
                [class.hover:bg-primary-50]="activeTab !== 'MountingProfiles'"
                (click)="switchTab('MountingProfiles')"
        >
            <span> {{ "MOUNTING_AND_FRAME" | translate }} </span>
        </div>
    }
</div>

}

@if(!printable()) {
    @switch (activeTab){
        @case ("Group") {
            <app-quantity-single-group [groupId]="activeGroupId" ></app-quantity-single-group>
        }
        @case ("Summary") {
            <app-quantity-collective-group
                    [accessories]="quantityCalculationService.accessories"
                    [lamellaCuttingPlan]="quantityCalculationService.lowestWasteCuttingPlan"
                    [mountingProfileCuttingPlan]="quantityCalculationService.mountingProfilesCuttingPlan"
                    [frameProfileCuttingPlan]="quantityCalculationService.frameProfilesCuttingPlan"

            ></app-quantity-collective-group>
        }
        @case ("CuttingPlan"){
            <app-cutting-plan [cuttingPlan]="quantityCalculationService.lowestWasteCuttingPlan" [type]="'LAMELLA'"></app-cutting-plan>
        }
        @case ("MountingProfiles"){
            <app-cutting-plan [cuttingPlan]="quantityCalculationService.mountingProfilesCuttingPlan" [cuttingPlanFrame]="quantityCalculationService.frameProfilesCuttingPlan" [type]="'MOUNTING_AND_FRAME'"></app-cutting-plan>
        }
        @default {
            <app-quantity-single-group></app-quantity-single-group>
        }
    }
}
@else {
    @switch (type()){
        @case ("QUANTITY") {
            <app-quantity-single-group></app-quantity-single-group>

            <h3 class="text-gray-700 font-bold text-xl mb-6 mt-6 uppercase" [style.page-break-before]="'always'">
                {{ "QUANTITY.TOTAL_QUANTITY"| translate}}
            </h3>
            <app-quantity-collective-group
                    [accessories]="quantityCalculationService.accessories"
                    [lamellaCuttingPlan]="quantityCalculationService.lowestWasteCuttingPlan"
                    [mountingProfileCuttingPlan]="quantityCalculationService.mountingProfilesCuttingPlan"
                    [frameProfileCuttingPlan]="quantityCalculationService.frameProfilesCuttingPlan"
            ></app-quantity-collective-group>
        }
        @case ("CUTTING_PLAN") {
            <app-cutting-plan [cuttingPlan]="quantityCalculationService.lowestWasteCuttingPlan" [type]="'LAMELLA'"></app-cutting-plan>
            <div [style.page-break-before]="'always'"></div>
            <app-cutting-plan
                    [cuttingPlan]="quantityCalculationService.mountingProfilesCuttingPlan"
                    [cuttingPlanFrame]="quantityCalculationService.frameProfilesCuttingPlan"
                    [type]="'MOUNTING_AND_FRAME'"
            ></app-cutting-plan>
        }
        @default {
            "Type not supported"
        }
    }
}






